import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Cms",
  "use": "Cms-usage",
  "viewBox": "0 0 36 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 31\" id=\"Cms\"><g fill-rule=\"evenodd\"><path d=\"M.563.063h34.874v30.375H.563V.063zM4.5 6.813V26.5h27V6.812h-27zm0-5.063v3.375h5.625V1.75H4.5z\" /><path d=\"M14.167 21.231L6.36 17.983v-2.032l7.807-3.241v2.437l-4.745 1.827 4.745 1.833v2.424zm7.753 0l7.807-3.248v-2.032L21.92 12.71v2.437l4.744 1.827-4.744 1.833v2.424z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol